import { DEFAULT_PHONE_REGION } from '@ofmos/shared/field-types';
import { Input } from '../../ui';
import { useFieldContext } from '../FieldContext';

/**
 * The user edits the ORIGINAL string; the canonical E.164 form is produced by the
 * server, which owns the phone-number library and the default region
 * (field-types.md decision 3). The client therefore keeps the previous canonical
 * value and marks it stale rather than guessing a new one - a wrong canonical
 * number would corrupt identity matching, which is the whole reason the column
 * exists.
 */
export function PhoneInput() {
  const { field, value, onChange, readOnly } = useFieldContext();
  const composite =
    value !== null && typeof value === 'object' && 'original' in value ? value : null;
  const region = field.options?.phoneDefaultRegion ?? DEFAULT_PHONE_REGION;

  return (
    <div className="space-y-1">
      <Input
        type="tel"
        inputMode="tel"
        value={composite?.original ?? ''}
        onChange={(event) =>
          onChange(
            event.target.value === ''
              ? null
              : { canonical: composite?.canonical ?? null, original: event.target.value },
          )
        }
        disabled={readOnly}
        aria-label={field.label}
        placeholder={`e.g. 0151 1234 5678 (${region})`}
      />
      <p className="text-2xs text-ink-subtle">
        Saved as typed. The canonical +{region} number is computed on the server.
      </p>
    </div>
  );
}
